import { cn } from '@@/lib/utils';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { signOut } from 'aws-amplify/auth';
import React, { lazy, Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import '@@/ui/theme/shadcn.css';

const TopBar = lazy(() => import('@@/ui/layouts/TopBar'));

const SideBar = lazy(() => import('./SideBar'));
import { useActiveBanner } from '@@/hooks/useActiveBanner';
import { BannerAlert } from '@@/ui/components/BannerAlert/BannerAlert';

const AdminWrapper = () => {
  const [isSideNavExpanded, setIsSideNavExpanded] = useState(false);

  useEffect(() => {
    (async () => {
      const result = await fetchUserAttributes();

      if (!result || Object.keys(result).length === 0) {
        signOut();
        return;
      }
    })();
  }, []);

  const pageSlug = getAdminPageSlug();

  return (
    <>
      <TopBar onMenuClick={() => setIsSideNavExpanded(!isSideNavExpanded)} />
      <SideBar isExpanded={isSideNavExpanded} setIsExpanded={setIsSideNavExpanded} />
      {/* Global portal banner just below top bar */}
      <AdminBannerRail isExpanded={isSideNavExpanded} pageSlug={pageSlug} />
      <Suspense>
        <main
          className={cn(
            'transition-all duration-300 h-[calc(100vh-3rem)] overflow-auto absolute scrollbar-custom',
            isSideNavExpanded ? 'w-[calc(100%-250px)] ml-[250px]' : 'w-[calc(100%-43px)] ml-[43px]',
            useBannerTopOffset(pageSlug)
          )}
        >
          <Outlet />
        </main>
      </Suspense>
    </>
  );
};

export default AdminWrapper;

function AdminBannerRail({ isExpanded, pageSlug }: { isExpanded: boolean; pageSlug?: string }) {
  const { banner, isLoading } = useActiveBanner(pageSlug);
  if (isLoading || !banner) return null;
  return (
    <div className={cn('fixed top-12 left-0 right-0 z-40', isExpanded ? 'left-[250px]' : 'left-[43px]')}>
      <BannerAlert brand='portal' message={banner.message} severity={banner.severity} updatedAt={banner.updatedAt} />
    </div>
  );
}

function useBannerTopOffset(pageSlug?: string) {
  const { banner, isLoading } = useActiveBanner(pageSlug);
  return !isLoading && banner ? 'top-[88px]' : 'top-12';
}

function getAdminPageSlug(): string | undefined {
  // Map admin routes to backend page slugs, if needed later
  return undefined;
}
